// extracted by mini-css-extract-plugin
export var fullGrid = "_2o-3";
export var pdpPreviewContainer = "_2o-1";
export var previewContainer = "_2o-0";
export var togglePreviewContainer = "_2o-2";